"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubnetsDropdown = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const formik_1 = require("formik");
const common_1 = require("../../../../common");
const toFormSelectOptions = (subnets) => {
    return subnets.map((hn, index) => ({
        label: `${hn.humanized}${hn.isValid ? '' : ' (Invalid network)'}`,
        value: hn.subnet,
        isDisabled: false,
        id: `form-input-hostSubnet-field-option-${index}`,
    }));
};
const makeNoSubnetSelectedOption = (availableSubnets) => ({
    label: `Please select a subnet. (${availableSubnets} available)`,
    value: common_1.NO_SUBNET_SET,
    isDisabled: true,
    id: 'form-input-hostSubnet-field-option-no-subnet-selected',
});
const noSubnetAvailableOption = {
    label: 'No subnets are currently available',
    value: common_1.NO_SUBNET_SET,
    isDisabled: true,
    id: 'form-input-hostSubnet-field-option-no-subnet-available',
};
const SubnetsDropdown = ({ name, machineSubnets, isDisabled }) => {
    const [field, , { setValue }] = (0, formik_1.useField)(name);
    const [isOpen, setOpen] = react_1.default.useState(false);
    const [currentDisplayValue, setCurrentDisplayValue] = react_1.default.useState();
    const fieldId = (0, common_1.getFieldId)(name, 'input');
    const itemsSubnets = react_1.default.useMemo(() => {
        return machineSubnets.length === 0
            ? [noSubnetAvailableOption]
            : [makeNoSubnetSelectedOption(machineSubnets.length)].concat(toFormSelectOptions(machineSubnets));
    }, [machineSubnets]);
    react_1.default.useEffect(() => {
        var _a;
        if (field.value) {
            // If the field already has a value then it must have been assigned from one of the entries in the `itemsSubnets`
            const subnetItem = itemsSubnets.find((item) => item.value === field.value);
            setCurrentDisplayValue((_a = subnetItem === null || subnetItem === void 0 ? void 0 : subnetItem.label) !== null && _a !== void 0 ? _a : itemsSubnets[0].label);
        }
        else {
            // When `itemsSubnets.length === 2`, there is a placeholder at index 0 and only one subnet at index 1.
            // In all the other cases the user should see the placeholder saying that either there is no subnet available
            // or there is more than one option they can choose from.
            const defaultValue = itemsSubnets.length === 2 ? itemsSubnets[1].label : itemsSubnets[0].label;
            setCurrentDisplayValue(defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dropdownItems = itemsSubnets.map(({ value, label, isDisabled }) => (react_1.default.createElement(react_core_1.DropdownItem, { key: value, id: value, isDisabled: isDisabled, value: value }, label)));
    const onSelect = (event, value) => {
        setCurrentDisplayValue(value);
        setValue(event === null || event === void 0 ? void 0 : event.currentTarget.id);
        setOpen(false);
    };
    const toggle = (toggleRef) => (react_1.default.createElement(react_core_1.MenuToggle, { ref: toggleRef, onClick: () => setOpen(!isOpen), isExpanded: isOpen, isDisabled: isDisabled, className: "pf-v5-u-w-100", id: fieldId }, currentDisplayValue));
    return (react_1.default.createElement(react_core_1.Dropdown, Object.assign({}, field, { id: `${fieldId}-dropdown`, onOpenChange: () => setOpen(!isOpen), onSelect: onSelect, toggle: toggle, isOpen: isOpen }), dropdownItems));
};
exports.SubnetsDropdown = SubnetsDropdown;
//# sourceMappingURL=SubnetsDropdown.js.map